import { TemplateTabs } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/types';

export const tabs = [
  { label: 'All', value: TemplateTabs.ALL },
  { label: 'Mine', value: TemplateTabs.MINE },
  { label: 'Shared', value: TemplateTabs.SHARED },
];

export const tabPanels = [
  { value: TemplateTabs.ALL, component: <>{TemplateTabs.ALL}</> },
  {
    value: TemplateTabs.MINE,
    component: <>{TemplateTabs.MINE}</>,
  },
  {
    value: TemplateTabs.SHARED,
    component: <>{TemplateTabs.SHARED}</>,
  },
];
